import Account from './src/account';

export default Account;
